import React from "react";
import { NoSettings } from "./sectionFormKit";

// Customer: components/sections/GlobalSearch/GlobalSearch.js
const GlobalSearch = () => <NoSettings text="Product search box. No settings." />;

export default GlobalSearch;
